import { render, staticRenderFns } from "./PromocodesCreate.vue?vue&type=template&id=1f014207&"
import script from "./PromocodesCreate.vue?vue&type=script&lang=js&"
export * from "./PromocodesCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports